const udhrPreamble = `
Enär erkännandet av det inneboende värdet hos alla medlemmar av människosläktet och av deras lika och oförytterliga rättigheter är grundvalen för frihet, rättvisa och fred i världen,

enär ringaktning och förakt för de mänskliga rättigheterna lett till barbariska gärningar, som upprört mänsklighetens samvete, och enär skapandet av en värld, där människorna åtnjuta yttrandefrihet, trosfrihet samt frihet från fruktan och nöd, kungjorts som folkens högsta strävan,

enär det är väsentligt för att icke människan skall tvingas att som en sista utväg tillgripa uppror mot tyranni och förtryck, att de mänskliga rättigheterna skyddas genom lagens överhöghet,

enär det är väsentligt att främja utvecklandet av vänskapliga förbindelser mellan nationerna,

enär Förenta Nationernas folk i stadgan ånyo uttryckt sin tro på de grundläggande mänskliga rättigheterna, den enskilda människans värdighet och värde samt männens och kvinnornas lika rättigheter, ävensom beslutat främja socialt framåtskridande och bättre levnadsvillkor under större frihet,

enär medlemsstaterna åtagit sig att i samverkan med Förenta Nationerna säkerställa allmän och effektiv respekt för de mänskliga rättigheterna och de grundläggande friheterna,

enär en gemensam uppfattning av dessa fri- och rättigheters innebörd är av största betydelse för uppfyllandet av detta åtagande,`;

const udhr1 =  `
Enär erkännandet av det inneboende värdet hos alla medlemmar av människosläktet och av deras lika och oförytterliga rättigheter är grundvalen för frihet, rättvisa och fred i världen,

enär ringaktning och förakt för de mänskliga rättigheterna lett till barbariska gärningar, som upprört mänsklighetens samvete, och enär skapandet av en värld, där människorna åtnjuta yttrandefrihet, trosfrihet samt frihet från fruktan och nöd, kungjorts som folkens högsta strävan,

enär det är väsentligt för att icke människan skall tvingas att som en sista utväg tillgripa uppror mot tyranni och förtryck, att de mänskliga rättigheterna skyddas genom lagens överhöghet,

enär det är väsentligt att främja utvecklandet av vänskapliga förbindelser mellan nationerna,

enär Förenta Nationernas folk i stadgan ånyo uttryckt sin tro på de grundläggande mänskliga rättigheterna, den enskilda människans värdighet och värde samt männens och kvinnornas lika rättigheter, ävensom beslutat främja socialt framåtskridande och bättre levnadsvillkor under större frihet,

enär medlemsstaterna åtagit sig att i samverkan med Förenta Nationerna säkerställa allmän och effektiv respekt för de mänskliga rättigheterna och de grundläggande friheterna,

enär en gemensam uppfattning av dessa fri- och rättigheters innebörd är av största betydelse för uppfyllandet av detta åtagande,`;

module.exports = {
    name: "Swedish",
    udhrPreamble,
    udhr1,
    lang: 'sv',
}